import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Booking from "./pages/Booking";
import ServiceAreas from "./pages/ServiceAreas";
import RedlandsCA from "./pages/RedlandsCA";
import LomaLindaCA from "./pages/LomaLindaCA";
import YucaipaCA from "./pages/YucaipaCA";
import RanchoCucamongaCA from "./pages/RanchoCucamongaCA";
import RiversideCA from "./pages/RiversideCA";
import SanBernardinoCA from "./pages/SanBernardinoCA";
import OntarioCA from "./pages/OntarioCA";
import CoronaCA from "./pages/CoronaCA";
import FontanaCA from "./pages/FontanaCA";
import CeramicCoating from "./pages/CeramicCoating";
import HeadlightRestoration from "./pages/HeadlightRestoration";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BookingConfirmation from "./pages/BookingConfirmation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes with Header/Footer */}
            <Route path="/" element={
              <>
                <Header />
                <main className="pt-20">
                  <Home />
                </main>
                <Footer />
              </>
            } />
            <Route path="/services" element={
              <>
                <Header />
                <main className="pt-20">
                  <Services />
                </main>
                <Footer />
              </>
            } />
            <Route path="/booking" element={
              <>
                <Header />
                <main className="pt-20">
                  <Booking />
                </main>
                <Footer />
              </>
            } />
            <Route path="/appointment-confirmation" element={
              <>
                <Header />
                <main className="pt-20">
                  <BookingConfirmation />
                </main>
                <Footer />
              </>
            } />
            
            {/* Service Areas Routes */}
            <Route path="/service-areas" element={
              <>
                <Header />
                <main className="pt-20">
                  <ServiceAreas />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/redlands-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <RedlandsCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/loma-linda-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <LomaLindaCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/yucaipa-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <YucaipaCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/rancho-cucamonga-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <RanchoCucamongaCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/riverside-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <RiversideCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/san-bernardino-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <SanBernardinoCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/ontario-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <OntarioCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/corona-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <CoronaCA />
                </main>
                <Footer />
              </>
            } />
            <Route path="/service-areas/fontana-ca" element={
              <>
                <Header />
                <main className="pt-20">
                  <FontanaCA />
                </main>
                <Footer />
              </>
            } />
            
            {/* Premium Service Pages */}
            <Route path="/services/ceramic-coating" element={
              <>
                <Header />
                <main className="pt-20">
                  <CeramicCoating />
                </main>
                <Footer />
              </>
            } />
            <Route path="/services/headlight-restoration" element={
              <>
                <Header />
                <main className="pt-20">
                  <HeadlightRestoration />
                </main>
                <Footer />
              </>
            } />
            
            {/* Blog Routes */}
            <Route path="/blog" element={
              <>
                <Header />
                <main className="pt-20">
                  <Blog />
                </main>
                <Footer />
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <Header />
                <main className="pt-20">
                  <BlogPost />
                </main>
                <Footer />
              </>
            } />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={
              <>
                <Header />
                <main className="pt-20">
                  <PrivacyPolicy />
                </main>
                <Footer />
              </>
            } />
            
            {/* Admin routes without Header/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
